import Api from '@/services/Api'

export default {
  index (query) {
    return Api().get('beton/showall', {
      params: query
    })
  },
  indexlist(search) {
    return Api().get('beton', {
      params: search
    })
  },
  companyFind (query) {
    return Api().get('beton/companyFind', {
      params: query
    })
  },
  choose (query) {
    return Api().get('beton/choose', {
      params: query
    })
  },
  show (id) {
    return Api().get(`beton/${id}`)
  },
  showOne (id) {
    return Api().get(`beton/one/${id}`)
  },
  post (newbeton) {
    return Api().post('beton', newbeton)
  },
  put (beton) {
    return Api().put(`beton/${beton.id}`, beton)
  },
  delete (id) {
    return Api().delete(`beton/delete/${id}`)
  },
  saveitems (newitems) {
    return Api().post('beton/saveitems', newitems)
  },
}